export const ERolesAction = {
  SET_ROLES: 'SET_ROLES',
};
